/**
 * 地形地貌
 */
class DZModelTopographic{
    /**
     * 土地信息ID
     */
    landId = "";

    /**
     * 地形坡度
     */
    terrainSlope = "";

    /**
     * 海拔高度
     */
    altitude = "";

    /**
     * 地块形状
     */
    lotShape = "";

    /**
     * 平整程度
     */
    flatness = "";

    /**
     * 排水条件
     */
    drainedCondition = "";

    /**
     * 灌溉条件
     */
    irrigationCondition = "";

    /**
     * 方位
     */
    position = "";

    /**
     * 地貌
     */
    landforms = "";
}
export default DZModelTopographic